import DefaultBlock from "../../components/main/DefaultBlock";
import { Grid, Typography } from "@mui/material";
import { Button, Box } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Link as RouterLink } from "react-router-dom";

import BlueprintBlock from "../../components/main/BlueprintBlock";
import SEO from "../../components/misc/SEO";
import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { IconButton, Tooltip } from "@mui/material";
import BlogColumn from "../../components/main/BlogColumn";
import ImageExperienceCard from "../../components/experience/ImageExperienceCard";
import YouTubeEmbed from "../../components/misc/YouTubeEmbed";
import LaunchIcon from "@mui/icons-material/Launch";

const experienceData = [
  {
    logoSrc: "/p/logokaidro_orig.png",
    company: "Kaidro (Gadgetbot)",
    subtitle: "Kaidro: Clan Battles",
    link: "https://kaidro.com/",
    time: "2023-2025",
    description:
      "I worked closely with other gameplay programmers to create new features in Unreal Engine, enhancing player interactions and game mechanics. In collaboration with the UI/UX team, I also helped develop high-quality mobile user interfaces using the Common UI plugin.",
  },
  {
    logoSrc: "/p/logopp_orig.png",
    company: "Project: Playtime (MOB Entertainment)",
    subtitle: "Project: Playtime",
    link: "https://www.mobentertainment.com/poppy-playtime",
    time: "2021-2023",
    description:
      "I developed the core infrastructure for the multiplayer title Project: Playtime, laying the foundation for its online features. I worked closely with the creative directors to create detailed game design documentation, ensuring the vision for the game was clearly defined.",
  },
  {
    logoSrc: "/p/logocivil2_orig.png",
    company: "Civil (Oversight Games)",
    subtitle: "Civil: The Game",
    link: "https://oversightgames.com/p/civil",
    time: "2018-2021",
    description:
      "I led the design process for a multiplayer life RPG which is currently still in active development. I took charge of creating core gameplay systems, including designing combat mechanics using Unreal Engine's Gameplay Ability System (GAS), providing fluid and dynamic combat interactions. I also implemented vehicle mechanics, allowing players to seamlessly drive and interact with vehicles within the game world.",
  },
  {
    logoSrc: "/p/logoa_orig.png",
    company: "Independent Work",
    subtitle: "On YouTube",
    link: "https://www.youtube.com/@aaronhunt7204",
    time: "2018-2021",
    description:
      "I solo-developed and published two games, Paradise and Ragdoll Destroyer, gaining valuable experience in the full game development process. To help others in the development community, I also created and shared YouTube tutorials, offering insights and tips to support fellow developers in their projects.",
  },
];

export default function GameplayPort() {
  return (
    <div>
      <SEO
        title="Portfolio | Aaron Hunt"
        image="https://www.aaronhunt.dev/blog/i/ragdoll.jpg"
      />
      <BlueprintBlock text="export default function App() {" />
      <DefaultBlock>
        <Grid container sx={{ width: "100%" }}>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              width: { md: "50%" },
              boxSizing: "border-box",
              pr: { md: 1 },
            }}
          >
            <Box
              sx={{
                py: 8,
                px: 2,
                pb: "20px",
                backgroundColor: "transparent",
                textAlign: "left",
                maxWidth: "100%",
              }}
            >
              <Typography sx={{ pb: 2, maxWidth: "512px", opacity: 0.5 }}>
                Aaron Hunt
              </Typography>
              <Typography variant="h4" fontWeight="bold">
                Gameplay Programmer & Designer
              </Typography>
              <Typography sx={{ pt: 2, maxWidth: "512px", opacity: 0.8 }}>
                Whether you're building a game, a product, or something in
                between, I’m here to help.
              </Typography>
            </Box>

            <Box sx={{ px: 2, mt: 3, display: "flex", gap: 2 }}>
              {[
                {
                  label: "Watch Video",
                  to: "https://www.youtube.com/watch?v=WYOt6XLZEI8",
                  color: "primary",
                },
                { label: "About Me", to: "/blog/about-me", color: "secondary" },
              ].map(({ label, to, color }) => (
                <Button
                  key={label}
                  variant="contained"
                  color={color}
                  target="_blank"
                  component={RouterLink}
                  to={to}
                  endIcon={<ArrowForwardIosIcon sx={{ height: 14 }} />}
                  sx={{
                    position: "relative",
                    overflow: "hidden",
                    transition: "all 0.3s ease",
                    "& .MuiButton-endIcon": {
                      opacity: 0.5,
                      transform: "translateX(-2px)",
                      transition: "all 0.3s ease",
                    },
                    "&:hover .MuiButton-endIcon": {
                      opacity: 1,
                      transform: "translateX(2px)",
                    },
                  }}
                >
                  {label}
                </Button>
              ))}
            </Box>
            <Box sx={{ display: "flex", gap: 1.5, px: 2, mt: 4, opacity: 0.6 }}>
              <Tooltip title="GitHub">
                <IconButton
                  component="a"
                  href="https://github.com/anhuntz/aaron-hunt-portfolio"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  <GitHubIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="LinkedIn">
                <IconButton
                  component="a"
                  href="https://www.linkedin.com/in/aaron-h-36332412b/"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  <LinkedInIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="YouTube">
                <IconButton
                  component="a"
                  href="https://www.youtube.com/@aaronhunt7204"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  <YouTubeIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Blog">
                <IconButton
                  component="a"
                  href="/blog"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  <img
                    src="/logo.svg"
                    alt="Custom Icon"
                    style={{ height: 24, width: 24 }}
                  />
                </IconButton>
              </Tooltip>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              width: { md: "50%" },
              boxSizing: "border-box",
              pl: { md: 1 },
            }}
          >
            <YouTubeEmbed videoId="WYOt6XLZEI8" />
          </Grid>
        </Grid>
      </DefaultBlock>
      <BlueprintBlock text="load previous.games" />
      <DefaultBlock>
        {" "}
        <Typography variant="h5" sx={{ p: 2, maxWidth: "512px", opacity: 0.8 }}>
          Games I've Contributed To
        </Typography>
        <Box className="backgroundGrid" sx={{ p: 2 }}>
          {experienceData.map((exp, index) => (
            <Box sx={{ mb: 2 }}>
              <ImageExperienceCard
                key={index}
                logoSrc={exp.logoSrc}
                company={exp.company}
                subtitle={exp.subtitle}
                link={exp.link}
                time={exp.time}
                description={exp.description}
              />
            </Box>
          ))}
        </Box>
      </DefaultBlock>
      <BlueprintBlock text="load projects(type: game)" />
      <DefaultBlock>
        <Typography variant="h5" sx={{ p: 2, maxWidth: "512px", opacity: 0.8 }}>
          Other Relevant Projects
        </Typography>
        <BlogColumn showProjects={true} limit={5} category="Gameplay" />
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <Button
            variant="contained"
            color="secondary"
            href="/blog"
            rel="noopener noreferrer"
            startIcon={<LaunchIcon />}
            sx={{ mt: 2, mb: 3 }}
          >
            View More Projects
          </Button>
        </Box>
      </DefaultBlock>
    </div>
  );
}
